<template>
  <address-form title="آدرس جدید" :submit-function="createAddress"/>
</template>

<script>
import AddressForm from '../Address/AddressForm';
import {mapActions} from 'vuex';

export default {
  name: "CreateAddress",
  components: {AddressForm},
  methods: {
    createAddress(form) {

      if (this.$route.query.mode === 'default-address') {
        form.default_address = 1;
      }

      this.$store.dispatch('Address/createAddress', {form: form, redirect: true});

    }

  }
};
</script>

<style scoped>
</style>